var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main---search",
    transform: "translate(-38.000000, -399.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(38.000000, 399.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_1_",
    d: "M19.9,11c-0.6,0-1.1,0.3-1.4,0.9l-3,6c-0.1,0.2-0.3,0.2-0.4,0.1c-0.1,0-0.1-0.1-0.2-0.2 L10.3,5.1c-0.3-0.8-1.2-1.3-2-0.9c-0.4,0-0.7,0.3-0.9,0.7l-3,6C4.3,11,4.2,11,4.1,11H0.6C0.3,11,0,11.3,0,11.7 c0,0.3,0.3,0.6,0.6,0.6h3.5c0.6,0,1.1-0.3,1.4-0.9l3-6c0.1-0.2,0.3-0.2,0.4-0.1C9,5.3,9,5.4,9.1,5.5l4.6,12.8 c0.2,0.6,0.8,1,1.4,1h0.1c0.6,0,1.1-0.3,1.4-0.9l3-6c0.1-0.1,0.2-0.2,0.3-0.2h3.5c0.3,0,0.6-0.3,0.6-0.6S23.7,11,23.4,11"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsicon);
export default __webpack_public_path__ + "static/media/stats.icon.59f03a3b.svg";
export { ForwardRef as ReactComponent };